import { EventsRecords, Metadata, SessionIdentity } from '@samelogic/steps';
import { Context } from '.';
import { SessionManager } from '../../tracking/sessions/SessionManager';
import {
  contextMetadataFactory,
  sessionIdentityFactory,
  workflowContextEventsFactory
} from '../__tests__/factories';

describe.only('Context', () => {
  let context: Context;
  let sessionManager: SessionManager;
  let workflowMetadata: Metadata;
  let workflowEvents: EventsRecords;

  let identity: SessionIdentity;

  beforeEach(() => {
    workflowMetadata = contextMetadataFactory.build();
    workflowEvents = workflowContextEventsFactory.build();
    identity = sessionIdentityFactory.build();

    sessionManager = new SessionManager('envId');
    sessionManager.setSessionIdentity(identity);

    context = new Context(sessionManager, workflowMetadata, workflowEvents);

    // sessionManagerMock.getSessionIdentity.mockResolvedValue(identity);
  });

  describe('identity', () => {
    it('should contain the identity', () => {
      expect(context.identity).toEqual(identity);
    });
    describe('when session manager identity is updated', () => {
      beforeEach(() => {
        identity = sessionIdentityFactory.build({
          userId: 'new-user-id'
        });
        sessionManager.setSessionIdentity(identity);
      });
      it('should update the identity', () => {
        expect(context.identity).toEqual(identity);
      });
    });
  });

  describe('events', () => {
    it('should contain the default event', () => {
      expect(context.events).toEqual(workflowEvents);
    });
  });

  describe('clone', () => {
    let newContext: Context;
    describe('when new events is passed in', () => {
      beforeEach(() => {
        workflowEvents = workflowContextEventsFactory.build({
          'new-test-step': {
            'test-event': {
              data: { test: 'test' }
            }
          }
        });
        newContext = context.clone(workflowEvents);
      });
      it('should clone the context and update the events', () => {
        expect(newContext.events).toEqual(workflowEvents);
        expect(newContext.identity).toEqual(context.identity);
        expect(newContext.metadata).toEqual(context.metadata);
      });
    });
    describe('when no events is not passed in', () => {
      beforeEach(() => {
        newContext = context.clone();
      });
      it('should clone the context with all default values', () => {
        expect(newContext.events).toEqual(context.events);
        expect(newContext.identity).toEqual(context.identity);
        expect(newContext.metadata).toEqual(context.metadata);
      });
    });
  });
});
